import { useEffect, useState } from "react";

function getWebGLFingerprint() {
  try {
    const canvas = document.createElement("canvas");
    const context =
      (canvas.getContext("webgl") as WebGLRenderingContext | null) ??
      (canvas.getContext("experimental-webgl") as WebGLRenderingContext | null);

    if (!context) return "no-webgl";

    const debugInfo = context.getExtension(
      "WEBGL_debug_renderer_info"
    ) as WEBGL_debug_renderer_info | null;
    const vendor = context.getParameter(context.VENDOR);
    const renderer = context.getParameter(context.RENDERER);

    const unmaskedVendor = debugInfo
      ? context.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
      : "";
    const unmaskedRenderer = debugInfo
      ? context.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      : "";

    return `${vendor}-${renderer}-${unmaskedVendor}-${unmaskedRenderer}`;
  } catch {
    return "webgl-error";
  }
}


function getCanvasFingerprint() {
  const canvas = document.createElement("canvas");
  canvas.width = 200;
  canvas.height = 50;
  const ctx = canvas.getContext("2d");

  if (!ctx) return "no-canvas";

  ctx.textBaseline = "top";
  ctx.font = "16px Arial";
  ctx.fillText("DeviceFingerprint", 2, 2);

  return canvas.toDataURL();
}

function hash(str: string) {
  let hash = 0;
  if (str.length === 0) return hash.toString();

  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash = hash & hash;
  }
  return hash.toString();
}

export function useDeviceSignature() {
  const [signature, setSignature] = useState("");

  useEffect(() => {
    const fingerprintData = [
      navigator.userAgent,
      navigator.language,
      navigator.platform,
      screen.width,
      screen.height,
      screen.colorDepth,
      getWebGLFingerprint(),
      getCanvasFingerprint(),
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    ].join("::");

    const finalHash = hash(fingerprintData);
    setSignature(finalHash);
  }, []);

  return signature;
}
